import {TRANSFORM_TYPE} from "utils/constants";
import produce from "immer";

const initialState = {
  transformType: TRANSFORM_TYPE.TRANSLATE,
  isActivated: false,
  snapProperty: {
    translateSnap: 1,
    rotateSnap: 15,
    scaleSnap: 0.25,
  },
};

const transform = (state = initialState, action) => {
  const {type, payload} = action;
  switch (type) {
    case TRANSFORM_TYPE.CHANGE_TRANSFORM:
      return produce(state, draft => {
        draft.transformType = payload;
      });
    case TRANSFORM_TYPE.SNAP_ON:
      return produce(state, draft => {
        draft.isActivated = true;
      });
    case TRANSFORM_TYPE.SNAP_OFF:
      return produce(state, draft => {
        draft.isActivated = false;
      });
    case TRANSFORM_TYPE.SET_SNAP_PROPERTY:
      return produce(state, draft => {
        draft.snapProperty = payload.snapProperty;
      });
    default:
      return state;
  }
};

export default transform;
